import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useSmMediaQuery } from '@lean-body/src/util';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { CourseDayHeader, CourseDayLessons } from '@lean-body/components/molecules';
export const CourseDayItem = ({ day, apiClient, classObject, onClick }) => {
    const isSM = useSmMediaQuery();
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(CourseDayHeader, { day: day, classObject: styles.header }),
        React.createElement(CourseDayLessons, { dayLesson: day.dailyLessonDayLesson, apiClient: apiClient, isMin: isSM, isVertical: true, classObject: styles.lessons, onClick: onClick })));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.White,
        border: `1px solid ${Colors.BorderLightGray}`,
        borderRadius: 10,
        padding: '10px 12px',
        [MediaBreakPointUp.MD]: {
            padding: 20,
        },
    },
    header: {},
    lessons: {
        marginTop: 10,
        [MediaBreakPointUp.MD]: {
            marginTop: 20,
        },
        [MediaBreakPointUp.XL]: {
            margin: '20 auto 0 0',
        },
    },
});
